import React from "react";

export default function Footer() {
  return (
    <div style={{ textAlign: "center" }}>
      <a
        href="https://github.com/f-parsa/weather_pro"
        target="_blank"
        rel="noreferrer"
      >
        Open-source code{" "}
      </a>
      by Fatemeh Parsa Seresht
    </div>
  );
}
